import Vue from 'vue'
import VueI18n from 'vue-i18n'
import localeEn from './locale/en.json';
import localeZhHant from './locale/zh-Hant.json';
import localeZhHans from './locale/zh-Hans.json';
import localeJp from './locale/jp.json'
import localeFr from './locale/fr.json'
import localeDe from './locale/de.json'

Vue.use(VueI18n)
const messages = {
  en: {
    ...localeEn,
  },
  zhHant: {
    ...localeZhHant
  },
  zhHans: {
    ...localeZhHans
  },
  ja: {
    ...localeJp
  },
  fr: {
    ...localeFr,
  },
  de: {
    ...localeDe,
  },
}

function getLang () {
  const language = navigator.languages && navigator.languages[0] ||
    navigator.language ||
    navigator.userLanguage ||
    ''

  const primary = String(language).split(/[-_]/)[0].toLowerCase()

  if (primary === 'zh') {
    if (
      language.includes('Hans') ||
      language.includes('CN') ||
      language.includes('SG')
    ) {
      return 'zhHans'
    }
    return 'zhHant'
  }
  if (primary === 'en') return 'en'
  if (primary === 'ja' || primary === 'jp') return 'ja'
  if (primary === 'fr') return 'fr'
  if (primary === 'de') return 'de'
  return 'en'
}

const lang = getLang() || 'zhHant'
const i18n = new VueI18n({
  locale: lang,
  messages,
})
export default i18n

// zh_Hant - 台灣
// zh_Hant - 香港
// zh_Hant - 澳門
// zh-Hans - 中國
// zh-Hans - 新加坡
// ['zh-TW', 'zh-CN', 'zh-HK']
